import { callApi } from '../services/apiService';
import { responseHandler } from '../handler/responseHandler';

export const Login = {
  signUpUser: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'signUp',
      params: params
    });
    return responseHandler(response);
  },
  login: async (params = {}) => {
    const response = callApi({
      method: 'POST',
      endpoint: 'loginuser',
      params: params
    });
    return responseHandler(response);
  },

    forgotPassword:async(params={})=>{
    const response = callApi({
      method: 'POST',
      endpoint: 'forgot-password',
      params: params
    });
    return responseHandler(response);
  },

  resetPassword:async(params={})=>{
    const response = callApi({
      method: 'POST', 
      endpoint: 'reset-password',
      params: params
    });
    return responseHandler(response);
  }
}